module.exports = __webpack_public_path__ + "img/square-list.993105f4.svg";